/* istanbul ignore file */
import { FormSection, FormRow } from 'framework/ui/layout';
import { Checkbox, TextInput, useFormContext } from 'framework/form';
import { NotDismissedEmployeeInput, EmployeeInput } from 'domain/shared/employee';
import { BudgetInput, BudgetsInput } from 'domain/shared/budget';

const ServiceForm = () => {
  const { data } = useFormContext();

  const getStaffingCoordinatorLabel = () => {
    const employee = data?.staffingCoordinator;

    if (!employee) {
      return undefined;
    }

    const alias = employee.alias || '';
    const firstName = employee.nameEn?.firstName || '';
    const lastName = employee.nameEn?.lastName || '';

    return `${alias} ${firstName} ${lastName}`;
  };

  return (
    <FormSection title="Service information">
      <FormRow>
        <TextInput source="name" label="Name" />
        <NotDismissedEmployeeInput source="ownerId" label="Owner" nameSource="ownerName" />
        <TextInput source="taskTrackerAlias" label="Redmine Project Alias" />
      </FormRow>
      <FormRow>
        <BudgetInput
          source="defaultBudgetId"
          nameSource="defaultBudget.name"
          label="Default Budget"
          searchString="name"
          filter={{ defaultableBudget: true, notArchived: true }}
        />
        <BudgetsInput filter={{ defaultableBudget: true, notArchived: true }} source="availableBudgets" />
      </FormRow>
      <FormRow>
        <EmployeeInput
          source="staffingCoordinatorAlias"
          label="Staffing Coordinator"
          initialLabel={getStaffingCoordinatorLabel()}
        />
      </FormRow>
      <FormRow>
        <Checkbox source="assignmentForbidden" label="Do not allow assignment creation" />
      </FormRow>
    </FormSection>
  );
};

export default ServiceForm;
